(function() {
    const CONFIG = {
        debug: false, 
        maxRetries: 20, 
        proxyUrl: '/apps/proxy/multi_ai_price'
    };

    const log = (...args) => { if (CONFIG.debug) console.log(...args); };
    const warn = (...args) => { if (CONFIG.debug) console.warn(...args); };
    const error = (...args) => { if (CONFIG.debug) console.error(...args); };

    log('[LOXA INIT]', 'Script loaded');

    let calcTimeout;
    let previousStateString = null; 
    let currentInsuranceData = null;
    let currentCalculatedTotal = 0; 
    let isIntercepting = false;
    let isExecutingCartAdd = false;
    let sidebarBindInterval = null;
    let fetchSequence = 0;
    let isFetching = false;
    let interceptBound = false;

    const getConfiguratorState = () => {
        const configurator = document.querySelector('.bed-configurator');
        if (!configurator) return null;

        let price = 0;
        const priceEl = document.getElementById('totalPrice');
        if (priceEl && priceEl.innerText) {
            price = parseFloat(priceEl.innerText.replace(/,/g, ''));
        }

        const selectedCards = configurator.querySelectorAll('.option-card.selected');
        let sizeId = null;
        let optionsStr = "";

        const EXCLUDED_STEPS = ['assembly-delivery', 'assembly', 'delivery'];
        let excludedPrice = 0;

        selectedCards.forEach(card => {
            const stepContent = card.closest('.step-content');
            if (!stepContent) return;

            const step = stepContent.dataset.stepContent;
            const optionName = card.querySelector('.option-main')?.innerText || card.dataset.colorName || "Option";

            if (step === 'size') {
                sizeId = card.dataset.option;
            } else if (EXCLUDED_STEPS.includes(step)) {
                excludedPrice += parseFloat(card.dataset.price) || 0;
            } else if (optionName !== 'Option') {
                optionsStr += `-${optionName.replace(/ /g, '')}`;
            }
        });

        if (excludedPrice > 0) {
            price -= excludedPrice;
        }

        const customHeight = document.getElementById('customHeadboardHeight');
        if (customHeight && customHeight.value && configurator.querySelector('[data-step-name="headboard"]')?.innerText.includes('Custom Height')) {
             optionsStr += `-Height${customHeight.value}cm`;
        }

        return { sizeId, price, optionsStr };
    };

    const getActiveVariantId = () => {
        const configState = getConfiguratorState();
        if (configState && configState.sizeId) return configState.sizeId;

        const customIdInput = document.getElementById('selected-variant-id');
        if (customIdInput && customIdInput.value) return customIdInput.value;

        const idInput = document.querySelector('.product-variant-id, product-form input[name="id"], form[action*="/cart/add"] input[name="id"], .size-variant-selector input[name="id"], input[name="id"]');
        if (idInput && idInput.value) return idInput.value;
        
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('variant')) return urlParams.get('variant');
        
        return window.ShopifyAnalytics?.meta?.selectedVariantId || null;
    };

    const getBaseProductInfo = () => {
        const activeVariantId = getActiveVariantId();
        let baseProductId = window.ShopifyAnalytics?.meta?.product?.id || "UNKNOWN_ID";
        let baseTitle = window.ShopifyAnalytics?.meta?.product?.title || document.querySelector('h1')?.innerText || "Product";

        let finalSku = String(baseProductId);
        let finalTitle = String(baseTitle);

        if (activeVariantId) finalSku += `-${activeVariantId}`;

        const configState = getConfiguratorState();
        if (configState && configState.optionsStr) {
            finalSku += configState.optionsStr;
            finalTitle += configState.optionsStr.replace(/-/g, ' | ');
        } else {
            if (window.ShopifyAnalytics?.meta?.product?.variants && activeVariantId) {
                const activeVariant = window.ShopifyAnalytics.meta.product.variants.find(v => v.id.toString() === activeVariantId.toString());
                if (activeVariant && activeVariant.name) finalTitle = activeVariant.name;
            }
        }

        return { sku: finalSku, title: finalTitle };
    };

    const LoxaController = {
        
        removeWidget: function() {
            const existingWidgets = document.querySelectorAll('.loxa-card[data-loxa-card-type="addon"], #loxa-shopify-offer');
            log('[LOXA WIDGET]', `removeWidget() — removing ${existingWidgets.length} widget(s)`);
            existingWidgets.forEach(widget => widget.remove());
        },

        toggleInclusiveOptOut: function(optOut) {
            log('[LOXA INCLUSIVE]', `toggleInclusiveOptOut(${optOut})`);
            const badge = document.querySelector('.loxa-inclusive-badge');
            if (!badge) {
                warn('[LOXA INCLUSIVE]', 'No .loxa-inclusive-badge found in DOM');
                return;
            }

            const title = badge.querySelector('.loxa-inclusive-title');
            const description = badge.querySelector('.loxa-inclusive-description');

            if (optOut) {
                badge.classList.add('loxa-opted-out');
                if (title) title.textContent = 'Free 3 Year Protection Removed';
                log('[LOXA INCLUSIVE]', 'Widget set to OPTED-OUT state');
                if (description) {
                    description.innerHTML = `
                        You've chosen not to include free protection.
                        <a href="#" class="loxa-readd-link">Add Free Protection</a>
                    `;
                    description.querySelector('.loxa-readd-link').addEventListener('click', (e) => {
                        e.preventDefault();
                        log('[LOXA INCLUSIVE]', '"Add Free Protection" link clicked — restoring');
                        const incCheckbox = badge.querySelector('#loxa-insurance-checkbox');
                        if (incCheckbox) {
                            incCheckbox.checked = true;
                            incCheckbox.dispatchEvent(new Event('change'));
                        }
                        this.toggleInclusiveOptOut(false);
                    });
                }
            } else {
                badge.classList.remove('loxa-opted-out');
                if (title) title.textContent = 'Free 3 Year Protection Included';
                log('[LOXA INCLUSIVE]', 'Widget restored to INCLUDED state');
                if (description) {
                    description.innerHTML = `
                        Protects you against accidental stains, accidental damage and structural defects.
                        <button class="loxa-learn-more-link loxa-inclusive-details-link" type="button">
                            <span class="loxa-learn-more-link-text">See Details</span>
                        </button>
                    `;
                    const detailsLink = description.querySelector('.loxa-inclusive-details-link');
                    if (detailsLink && currentInsuranceData) {
                        detailsLink.addEventListener('click', (e) => {
                            e.preventDefault();
                            log('[LOXA INCLUSIVE]', '"See Details" clicked — opening sidebar');
                            const inclusivePlan = currentInsuranceData.insurances.find(p => p.inclusive_insurance);
                            const addToCartButton = document.getElementById('addToCart') || document.querySelector('button.product-form__submit[name="add"], .btn-add-cart');
                            const addToCartForm = addToCartButton ? addToCartButton.closest('form') : null;
                            LoxaController.openSidebar(currentInsuranceData, addToCartButton, addToCartForm, false, inclusivePlan);
                        });
                    }
                }
            }
        },

        openSidebar: function(fullData, addToCartButton, addToCartForm, isSecondChance = false, specificPlan = null) {
            log('[LOXA SIDEBAR]', `openSidebar() — isSecondChance=${isSecondChance}, specificPlan=${specificPlan?.code || 'none'}, integration=${fullData?.integration_type}`);
            if (!fullData || !fullData.insurable || !fullData.active) {
                warn('[LOXA SIDEBAR]', 'Bailed — fullData not insurable/active');
                return;
            }
            
            if (window.LoxaShopifyDev?.openSidebarForInsurance) {
                log('[LOXA SIDEBAR]', 'Using LoxaShopifyDev.openSidebarForInsurance');
                window.LoxaShopifyDev.openSidebarForInsurance(fullData); 
            } else if (window.LoxaShopify?.openSidebar) {
                log('[LOXA SIDEBAR]', 'Using LoxaShopify.openSidebar');
                window.LoxaShopify.openSidebar(fullData);
            } else {
                warn('[LOXA SIDEBAR]', 'No Loxa sidebar API found');
            }

            if (addToCartButton) {
                this.bindSidebarActions(fullData, addToCartButton, addToCartForm, isSecondChance, specificPlan);
            }
        },

        buildHybridSidebarHTML: function(plan, isSecondChance) {
            const isInclusive = plan.inclusive_insurance;
            log('[LOXA SIDEBAR]', `buildHybridSidebarHTML() — plan=${plan.code}, isInclusive=${isInclusive}, isSecondChance=${isSecondChance}`);

            const sidebarData = plan.insurance_content?.sidebar_content || {};
            const header = sidebarData.header || (isInclusive ? '3 Years of Protection Included' : 'Add Protection, Enjoy Peace of Mind');
            const subheading = sidebarData.subheading || (isInclusive ? 'This product includes 3 Year Extended Warranty & Accidental Damage protection at no cost to you.' : '');
            const termsHeading = sidebarData.terms?.heading || 'What to expect';
            const rawTermsLines = sidebarData.terms?.lines || [];
            
            let dynamicLinks = {};
            const validDisplayLines = [];

            rawTermsLines.forEach((lineItem) => {
                if (!lineItem) return;
                if (typeof lineItem === 'object' && lineItem.links) {
                    dynamicLinks = { ...dynamicLinks, ...lineItem.links };
                    return; 
                }
                let lineText = typeof lineItem === 'string' ? lineItem : (lineItem.html || lineItem.text || lineItem.content || lineItem.label || JSON.stringify(lineItem));
                if (lineText.includes('{"links":')) {
                    try {
                        const parsed = JSON.parse(lineText);
                        if (parsed.links) dynamicLinks = { ...dynamicLinks, ...parsed.links };
                    } catch(e) {}
                    return; 
                }
                validDisplayLines.push(lineText);
            });

            let termsHTML = '';
            validDisplayLines.forEach((lineText) => {
                lineText = lineText.replace(/{tick}/g, '');
                lineText = lineText.replace(/{%IPID%}/g, () => dynamicLinks["IPID"] ? `<a href="${dynamicLinks["IPID"]}" target="_blank" rel="noopener noreferrer">IPID</a>` : 'IPID');
                lineText = lineText.replace(/{%Policy Wording%}/g, () => dynamicLinks["Policy Wording"] ? `<a href="${dynamicLinks["Policy Wording"]}" target="_blank" rel="noopener noreferrer">Policy Wording</a>` : 'Policy Wording');
                const isExclusion = lineText.toLowerCase().includes('does not cover') || lineText.toLowerCase().includes('excluded') || lineText.toLowerCase().includes('wear and tear');
                const icon = isExclusion 
                    ? `<svg fill="#000000" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M2 7.75A.75.75 0 0 1 2.75 7h10a.75.75 0 0 1 0 1.5h-10A.75.75 0 0 1 2 7.75Z"></path></svg>`
                    : `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#111827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5l10 -10"></path></svg>`;
                termsHTML += `<li>${icon}<span>${lineText}</span></li>`;
            });

            const extCheckbox = document.querySelector('.loxa-extended-badge .loxa-offer-checkbox');
            const isExtensionSelected = extCheckbox && extCheckbox.checked;
            log('[LOXA SIDEBAR]', `Extension checkbox — found:${!!extCheckbox}, checked:${extCheckbox?.checked}, isExtensionSelected:${isExtensionSelected}`);

            let finalHTML = '';
            if (isInclusive && !isSecondChance) {
                const optoutDisplay = isExtensionSelected ? 'none' : 'block';
                log('[LOXA SIDEBAR]', `optoutDisplay = ${optoutDisplay}`);
                finalHTML = `<div class="loxa-sidebar-content-root"><div class="loxa-sidebar-intro"><h3>${header}</h3><p class="loxa-sidebar-powered-by">Powered by Loxa</p><p class="loxa-sidebar-subheading">${subheading}</p></div><div class="loxa-sidebar-extra"><div class="loxa-sidebar-terms"><h4>${termsHeading}</h4><ul>${termsHTML}</ul><p class="loxa-footer-pill">This protection is paid for by the retailer at no cost to you.</p><div class="loxa-sidebar-legal"><p>This insurance is only available to residents of the UK. Loxa is an insurance intermediary authorised and regulated by the Financial Conduct Authority (FCA no. 1018666). Your cover is underwritten by Helvetia Global Solutions Ltd (FCA no. 454140).</p></div></div></div><button type="button" class="loxa-back-to-product" style="display: block; width: 100%; padding: 12px; margin-bottom: 10px; margin-top: 20px; background: #fff; color: #000; font-weight: bold; border: 1px solid #e5e7eb; border-radius: 4px; cursor: pointer;">Back to Product</button><button type="button" class="loxa-inclusive-optout" style="display: ${optoutDisplay} !important; background: none; border: none; color: #999; text-decoration: underline; cursor: pointer; width: 100%; font-size: 0.9em; text-align: center; padding: 5px;">I don't want complimentary protection</button></div>`;
            } else {
                finalHTML = `<div class="loxa-sidebar-content-root"><div class="loxa-sidebar-intro"><h3>${header}</h3><p class="loxa-sidebar-powered-by">Powered by Loxa</p><p class="loxa-sidebar-subheading">${subheading}</p></div><label class="loxa-sidebar-option loxa-selected" data-loxa-code="${plan.code}"><input type="radio" name="loxa-sidebar-insurance" value="${plan.code}" checked style="display:none;"><div class="loxa-sidebar-option-body"><div class="loxa-sidebar-option-main"><span class="loxa-sidebar-option-circle"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5l10 -10"></path></svg></span><span class="loxa-sidebar-option-title">${plan.insurance_term} Year protection</span></div><span class="loxa-sidebar-option-price">£${plan.insurance_price}</span></div></label><div class="loxa-sidebar-actions"><button type="button" class="loxa-sidebar-cta">Add with Protection</button><button type="button" class="loxa-sidebar-remove" style="display: none;">Remove Protection</button></div>${isSecondChance ? `<div><button type="button" class="loxa-second-chance-continue" style="display: block; background: none; border: none; color: #666; text-decoration: underline; cursor: pointer; width: 100%; font-size: 0.9em; text-align: center; padding: 5px;">Continue without protection</button></div>` : ''}<div class="loxa-sidebar-extra" style="margin-top:20px;"><div class="loxa-sidebar-terms"><h4>${termsHeading}</h4><ul>${termsHTML}</ul><div class="loxa-sidebar-legal"><p>This insurance is only available to residents of the UK. Loxa is an insurance intermediary authorised and regulated by the Financial Conduct Authority (FCA no. 1018666). Your cover is underwritten by Helvetia Global Solutions Ltd (FCA no. 454140).</p></div></div></div></div>`;
            }

            log('[LOXA SIDEBAR]', 'buildHybridSidebarHTML() complete');
            return finalHTML;
        },

        bindSidebarActions: function(fullData, addToCartButton, addToCartForm, isSecondChance, specificPlan) {
            log('[LOXA SIDEBAR-BIND]', `bindSidebarActions() — isSecondChance=${isSecondChance}, existingInterval=${!!sidebarBindInterval}`);
            
            if (sidebarBindInterval) {
                log('[LOXA SIDEBAR-BIND]', 'Clearing previous polling interval');
                clearInterval(sidebarBindInterval);
                sidebarBindInterval = null;
            }

            let checkCount = 0;
            sidebarBindInterval = setInterval(() => {
                let sidebarContainer = document.getElementById('loxa-shopify-sidebar-content') || document.querySelector('.loxa-sidebar-container');
                let actionsContainer = document.querySelector('.loxa-sidebar-actions') || document.querySelector('.loxa-back-to-product');
                
                if (sidebarContainer || actionsContainer) {
                    clearInterval(sidebarBindInterval);
                    sidebarBindInterval = null;
                    log('[LOXA SIDEBAR-BIND]', `Sidebar found after ${checkCount} polls — binding actions`);

                    if (fullData.integration_type === 'hybrid_extension') {
                        const planToRender = specificPlan || fullData.insurances.find(p => p.extension);
                        if (planToRender && sidebarContainer) {
                            log('[LOXA SIDEBAR-BIND]', `Rendering hybrid sidebar HTML for plan: ${planToRender.code}`);
                            sidebarContainer.innerHTML = this.buildHybridSidebarHTML(planToRender, isSecondChance);
                        }
                    }

                    let addBtn = document.querySelector('.loxa-sidebar-cta');
                    let removeBtn = document.querySelector('.loxa-sidebar-remove');
                    let closeBtn = document.querySelector('.loxa-sidebar-close');
                    let continueBtn = document.querySelector('.loxa-second-chance-continue') || document.querySelector('.loxa-sidebar-continue');
                    let backBtn = document.querySelector('.loxa-back-to-product');
                    let optoutBtn = document.querySelector('.loxa-inclusive-optout');

                    log('[LOXA SIDEBAR-BIND]', `Found buttons — add:${!!addBtn} remove:${!!removeBtn} close:${!!closeBtn} continue:${!!continueBtn} back:${!!backBtn} optout:${!!optoutBtn}`);

                    if (backBtn) {
                        backBtn.addEventListener('click', () => {
                            log('[LOXA SIDEBAR-BTN]', '"Back to Product" clicked');
                            this.closeSidebar();
                        });
                    }

                    if (optoutBtn) {
                        // React to extension checkbox changes while sidebar is open
                        if (!this._optoutSyncBound) {
                            this._optoutSyncBound = true;

                            const updateOptoutVisibility = () => {
                                const optout = document.querySelector('.loxa-inclusive-optout');
                                if (!optout) return;
                                const extCbNow = document.querySelector('.loxa-extended-badge .loxa-offer-checkbox');
                                const shouldHide = extCbNow && extCbNow.checked;
                                optout.style.setProperty('display', shouldHide ? 'none' : 'block', 'important');
                                log('[LOXA SIDEBAR-BIND]', `Opt-out visibility updated → ${shouldHide ? 'hidden' : 'visible'}`);
                            };

                            // Listen for native change events on the extension checkbox
                            document.addEventListener('change', (e) => {
                                if (e.target.closest('.loxa-extended-badge')) {
                                    updateOptoutVisibility();
                                }
                            });

                            // Listen for clicks on the extension badge (covers card-level toggles)
                            document.addEventListener('click', (e) => {
                                if (e.target.closest('.loxa-extended-badge')) {
                                    setTimeout(updateOptoutVisibility, 50);
                                }
                            });
                        }

                        optoutBtn.addEventListener('click', () => {
                            log('[LOXA SIDEBAR-BTN]', '"I don\'t want complimentary protection" clicked');
                            const incCheckbox = document.querySelector('.loxa-inclusive-badge #loxa-insurance-checkbox');
                            log('[LOXA SIDEBAR-BTN]', `Inclusive checkbox found: ${!!incCheckbox}, was checked: ${incCheckbox?.checked}`);
                            if (incCheckbox) {
                                incCheckbox.checked = false;
                                incCheckbox.dispatchEvent(new Event('change'));
                            }
                            this.toggleInclusiveOptOut(true);
                            this.closeSidebar();
                        });
                    }

                    if (isSecondChance) {
                        if (!continueBtn) {
                            log('[LOXA SIDEBAR-BIND]', 'Creating "Continue without protection" button (was missing)');
                            continueBtn = document.createElement('button');
                            continueBtn.type = 'button';
                            continueBtn.className = 'loxa-sidebar-continue loxa-second-chance-continue';
                            continueBtn.innerText = 'Continue without protection';
                            continueBtn.style.cssText = 'display: block; background: none; border: none; color: #666; text-decoration: underline; cursor: pointer; width: 100%; font-size: 0.9em; text-align: center; padding: 5px; margin-top: 10px;';
                            const mainActions = document.querySelector('.loxa-sidebar-actions');
                            if (mainActions) mainActions.insertAdjacentElement('afterend', continueBtn);
                        }
                        
                        continueBtn.style.display = 'block';
                        const newContinueBtn = continueBtn.cloneNode(true);
                        continueBtn.parentNode.replaceChild(newContinueBtn, continueBtn);
                        continueBtn = newContinueBtn;

                        continueBtn.addEventListener('click', () => {
                            log('[LOXA SIDEBAR-BTN]', `"Continue without protection" clicked — disabled=${continueBtn.disabled}, isExecutingCartAdd=${isExecutingCartAdd}`);
                            if (continueBtn.disabled || isExecutingCartAdd) {
                                warn('[LOXA SIDEBAR-BTN]', 'BLOCKED — button disabled or cart add in progress');
                                return;
                            }
                            continueBtn.disabled = true;

                            let extCheckbox = document.querySelector('.loxa-extended-badge .loxa-offer-checkbox') || document.getElementById('loxa-insurance-checkbox');
                            if (extCheckbox) extCheckbox.checked = false; 

                            this.closeSidebar();
                            
                            const incCheckbox = document.querySelector('.loxa-inclusive-badge #loxa-insurance-checkbox');
                            log('[LOXA SIDEBAR-BTN]', `Hybrid=${fullData.integration_type === 'hybrid_extension'}, incChecked=${incCheckbox?.checked}`);
                            if (fullData.integration_type === 'hybrid_extension' && incCheckbox && incCheckbox.checked) {
                                const incPlan = fullData.insurances.find(p => p.inclusive_insurance);
                                if (incPlan) {
                                    log('[LOXA SIDEBAR-BTN]', `Adding inclusive plan to cart: ${incPlan.code}`);
                                    this.executeCartAdd(addToCartForm, addToCartButton, incPlan);
                                    setTimeout(() => { continueBtn.disabled = false; }, 2000);
                                    return; 
                                }
                            }

                            log('[LOXA SIDEBAR-BTN]', 'Passing through to native ATC click');
                            isIntercepting = true;
                            setTimeout(() => {
                                addToCartButton.click();
                                setTimeout(() => {
                                    isIntercepting = false;
                                    continueBtn.disabled = false;
                                }, 1000);
                            }, 150); 
                        });
                    } else if (continueBtn) {
                        continueBtn.style.display = 'none';
                    }

                    if (addBtn) {
                        const newAddBtn = addBtn.cloneNode(true);
                        addBtn.parentNode.replaceChild(newAddBtn, addBtn);
                        addBtn = newAddBtn;

                        addBtn.addEventListener('click', () => {
                            log('[LOXA SIDEBAR-BTN]', `"Add with Protection" clicked — disabled=${addBtn.disabled}, isExecutingCartAdd=${isExecutingCartAdd}`);
                            if (addBtn.disabled || isExecutingCartAdd) {
                                warn('[LOXA SIDEBAR-BTN]', 'BLOCKED — button disabled or cart add in progress');
                                return;
                            }
                            addBtn.disabled = true;

                            let extCheckbox = document.querySelector('.loxa-extended-badge .loxa-offer-checkbox') || document.getElementById('loxa-insurance-checkbox');
                            if (extCheckbox) {
                                extCheckbox.checked = true;
                                extCheckbox.dispatchEvent(new Event('change')); 
                                log('[LOXA SIDEBAR-BTN]', 'Extension checkbox checked');
                            }

                            // Restore inclusive protection if it was opted out
                            const incBadge = document.querySelector('.loxa-inclusive-badge');
                            if (incBadge && incBadge.classList.contains('loxa-opted-out')) {
                                const incCheckbox = incBadge.querySelector('#loxa-insurance-checkbox');
                                if (incCheckbox) {
                                    incCheckbox.checked = true;
                                    incCheckbox.dispatchEvent(new Event('change'));
                                }
                                log('[LOXA SIDEBAR-BTN]', 'Restoring inclusive protection (extension added from sidebar)');
                                this.toggleInclusiveOptOut(false);
                            }

                            this.closeSidebar(); 

                            if (isSecondChance) {
                                const targetPlan = this.getSelectedSidebarPlan() || fullData.insurances.find(p => p.default_selected) || fullData.insurances.find(p => p.extension) || fullData.insurances[0];
                                log('[LOXA SIDEBAR-BTN]', `Second chance — executing cart add for plan: ${targetPlan?.code}`);
                                this.executeCartAdd(addToCartForm, addToCartButton, targetPlan);
                            }

                            setTimeout(() => { addBtn.disabled = false; }, 2000);
                        });
                    }

                    if (removeBtn) {
                        const newRemoveBtn = removeBtn.cloneNode(true);
                        removeBtn.parentNode.replaceChild(newRemoveBtn, removeBtn);
                        removeBtn = newRemoveBtn;

                        removeBtn.addEventListener('click', () => {
                            log('[LOXA SIDEBAR-BTN]', '"Remove Protection" clicked');
                            let checkbox = document.querySelector('.loxa-extended-badge .loxa-offer-checkbox') || document.getElementById('loxa-insurance-checkbox');
                            if (checkbox) {
                                checkbox.checked = false; 
                                checkbox.dispatchEvent(new Event('change'));
                            }
                            this.closeSidebar();

                            if (isSecondChance) {
                                log('[LOXA SIDEBAR-BTN]', 'Second chance remove — passing through to native ATC');
                                isIntercepting = true;
                                setTimeout(() => {
                                    addToCartButton.click();
                                    setTimeout(() => isIntercepting = false, 1000);
                                }, 150); 
                            }
                        });
                    }

                    if (closeBtn && !closeBtn.dataset.bound) {
                        closeBtn.dataset.bound = "true";
                        closeBtn.addEventListener('click', () => {
                            log('[LOXA SIDEBAR-BTN]', '"Close sidebar" clicked — cleaning up interval');
                            if (sidebarBindInterval) {
                                clearInterval(sidebarBindInterval);
                                sidebarBindInterval = null;
                            }
                        });
                    }
                }
                if (checkCount++ > 20) {
                    warn('[LOXA SIDEBAR-BIND]', 'Max poll count (20) reached — giving up');
                    clearInterval(sidebarBindInterval);
                    sidebarBindInterval = null;
                }
            }, 200);
        },
                
        getSelectedSidebarPlan: function() {
            if (!currentInsuranceData || !currentInsuranceData.insurances) return null;
            const optionNode = document.querySelector('.loxa-sidebar-option.loxa-selected');
            let selectedCode = optionNode?.getAttribute('data-loxa-code');
            if (!selectedCode) {
                const checkedRadio = document.querySelector('input[name="loxa-sidebar-insurance"]:checked');
                if (checkedRadio) selectedCode = checkedRadio.value;
            }
            if (selectedCode) {
                const plan = currentInsuranceData.insurances.find(p => p.code === selectedCode) || null;
                log('[LOXA SIDEBAR]', `getSelectedSidebarPlan() → ${plan?.code || 'null'}`);
                return plan;
            }
            return null;
        },

        closeSidebar: function() {
            log('[LOXA SIDEBAR]', `closeSidebar() — clearing interval: ${!!sidebarBindInterval}`);
            if (sidebarBindInterval) {
                clearInterval(sidebarBindInterval);
                sidebarBindInterval = null;
            }
            document.querySelector('.loxa-sidebar-close')?.click(); 
        },

        executeCartAdd: async function(addToCartForm, addToCartButton, targetPlan) {
            log('[LOXA CART-ADD]', `executeCartAdd() called — plan=${targetPlan?.code}, price=£${targetPlan?.insurance_price}`);
            log('[LOXA CART-ADD]', `FLAGS: ${"isIntercepting=" + isIntercepting + " isExecutingCartAdd=" + isExecutingCartAdd + " isFetching=" + isFetching + " fetchSeq=" + fetchSequence}`);
            
            if (isExecutingCartAdd) {
                warn('[LOXA CART-ADD]', '⛔ BLOCKED — already executing, skipping duplicate');
                return;
            }
            isExecutingCartAdd = true;
            isIntercepting = true;
            log('[LOXA CART-ADD]', 'Flags set: isExecutingCartAdd=true, isIntercepting=true');
            
            const spinner = addToCartButton.querySelector('.loading__spinner');
            
            try {
                addToCartButton.classList.add('loading');
                if (spinner) spinner.classList.remove('hidden');

                log('[LOXA CART-ADD]', `Finding matching variant for price: £${targetPlan.insurance_price}`);
                const insuranceVariantId = await this.findMatchingVariantId(targetPlan.insurance_price);
                log('[LOXA CART-ADD]', `Variant ID found: ${insuranceVariantId}`);
                
                if (!insuranceVariantId) {
                    error('[LOXA CART-ADD]', 'No matching variant — falling through to native ATC');
                    addToCartButton.click(); 
                    return;
                }

                const baseProductInfo = getBaseProductInfo(); 
                const sumInsuredRaw = currentInsuranceData.sum_insured || currentCalculatedTotal;
                const formattedSumInsured = parseFloat(sumInsuredRaw).toFixed(2);
                const actualCode = targetPlan.code || currentInsuranceData.code;
                const actualTerm = targetPlan.insurance_term || "N/A";
                
                const insuranceProperties = {
                    "_Premium": `£${targetPlan.insurance_price}`,
                    "Sum Insured": `£${formattedSumInsured}`,
                    "Insured Product": baseProductInfo.title, 
                    "_insuredProductId": baseProductInfo.sku, 
                    "_Category": currentInsuranceData.insurance_category || "General", 
                    "_loxaTerm": actualTerm,
                    "_Source": "online"
                };

                if (targetPlan.inclusive_insurance) {
                    insuranceProperties["_loxaInclusiveCode"] = actualCode;
                    log('[LOXA CART-ADD]', `Inclusive plan — code: ${actualCode}`);
                } else if (currentInsuranceData.integration_type === 'hybrid_extension') {
                    insuranceProperties["_loxaInsuranceCode"] = actualCode;
                    const inclusivePlan = currentInsuranceData.insurances.find(p => p.inclusive_insurance);
                    if (inclusivePlan) insuranceProperties["_loxaInclusiveCode"] = inclusivePlan.code;
                    log('[LOXA CART-ADD]', `Hybrid extension — extCode=${actualCode}, incCode=${inclusivePlan?.code}`);
                } else if (actualCode) {
                    insuranceProperties["_loxaInsuranceCode"] = actualCode;
                    log('[LOXA CART-ADD]', `Standard plan — code: ${actualCode}`);
                }

                log('[LOXA CART-ADD]', 'POSTing to /cart/add.js', { variantId: insuranceVariantId, properties: insuranceProperties });
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: insuranceVariantId, quantity: 1, properties: insuranceProperties }] })
                });

                if (response.ok) {
                    log('[LOXA CART-ADD]', 'Insurance added to cart successfully');
                    let checkbox = document.querySelector('.loxa-extended-badge .loxa-offer-checkbox') || document.getElementById('loxa-insurance-checkbox');
                    if (checkbox) checkbox.checked = false;
                    log('[LOXA CART-ADD]', 'Triggering native ATC click in 100ms');
                    setTimeout(() => addToCartButton.click(), 100);
                } else {
                    error('[LOXA CART-ADD]', `Cart add failed — HTTP ${response.status}`);
                    alert("There was an issue adding the insurance to the cart.");
                    if (spinner) spinner.classList.add('hidden');
                    addToCartButton.classList.remove('loading');
                }
            } catch (error) {
                error('[LOXA CART-ADD]', 'Fatal error:', error);
                if (spinner) spinner.classList.add('hidden');
                addToCartButton.classList.remove('loading');
            } finally {
                log('[LOXA CART-ADD]', 'Scheduling flag reset in 1500ms');
                setTimeout(() => {
                    isIntercepting = false;
                    isExecutingCartAdd = false;
                    log('[LOXA CART-ADD]', 'Flags reset: isIntercepting=false, isExecutingCartAdd=false');
                }, 1500); 
            }
        },

        renderWidget: function(data, selectedCode) {
            log('[LOXA WIDGET]', `renderWidget() — integration=${data.integration_type}, selectedCode=${selectedCode || 'none'}, plans=${data.insurances?.length}`);
            this.removeWidget();

            const configuratorActions = document.querySelector('.addtocart-wrapper, .actions-container-wrapper, .actions-container');
            const addToCartBtn = document.getElementById('addToCart') || document.querySelector('button.product-form__submit[name="add"], button.add-to-cart, form[action*="/cart/add"] [type="submit"], .btn-add-cart');
            const targetDOMNode = addToCartBtn ? addToCartBtn : configuratorActions;

            if (!targetDOMNode) {
                warn('[LOXA WIDGET]', 'No target DOM node found for widget insertion');
                return;
            }

            if (data.integration_type === 'hybrid_extension') {
                const inclusivePlan = data.insurances.find(plan => plan.inclusive_insurance && plan.html_content);
                const extensionPlan = data.insurances.find(plan => plan.extension && plan.html_content);
                log('[LOXA WIDGET]', `Hybrid — inclusive:${inclusivePlan?.code || 'none'} extension:${extensionPlan?.code || 'none'}`);
                
                // Insert extension widget first (before ATC button)
                if (extensionPlan) {
                    const insertMethod = addToCartBtn ? 'beforebegin' : 'afterbegin';
                    targetDOMNode.insertAdjacentHTML(insertMethod, extensionPlan.html_content);
                    this.attachEventListeners(extensionPlan, data, 'extension');
                    log('[LOXA WIDGET]', 'Extension widget inserted');
                }

                // Then insert inclusive widget directly above the extension widget
                if (inclusivePlan) {
                    const extensionWidget = document.querySelector('.loxa-extended-badge');
                    if (extensionWidget) {
                        extensionWidget.insertAdjacentHTML('beforebegin', inclusivePlan.html_content);
                    } else {
                        // Fallback: insert before ATC button if extension widget not found
                        const insertMethod = addToCartBtn ? 'beforebegin' : 'afterbegin';
                        targetDOMNode.insertAdjacentHTML(insertMethod, inclusivePlan.html_content);
                    }
                    this.attachEventListeners(inclusivePlan, data, 'inclusive');
                    log('[LOXA WIDGET]', 'Inclusive widget inserted above extension widget');
                }
            } 
            else {
                let targetPlan;
                if (selectedCode) targetPlan = data.insurances.find(plan => plan.code === selectedCode && plan.html_content);
                if (!targetPlan) targetPlan = data.insurances.find(plan => plan.default_selected && plan.html_content) || data.insurances.find(plan => plan.html_content) || data.insurances[0];
                if (!targetPlan || !targetPlan.html_content) {
                    warn('[LOXA WIDGET]', 'No target plan found with html_content');
                    return;
                }

                data.insurances.forEach(plan => { plan.default_selected = (plan.code === targetPlan.code); });
                const insertMethod = addToCartBtn ? 'beforebegin' : 'afterbegin';
                targetDOMNode.insertAdjacentHTML(insertMethod, targetPlan.html_content);
                this.attachEventListeners(targetPlan, data, 'standard');
                log('[LOXA WIDGET]', `Standard widget inserted — plan: ${targetPlan.code}`);
            }

            this.syncSidebarSelectionToWidget();
        },

        syncSidebarSelectionToWidget: function() {
            if (!this.syncBound) {
                this.syncBound = true;
                log('[LOXA SYNC]', 'Binding sidebar↔widget sync listener (once)');
                const syncHandler = (e) => {
                    const optionEl = e.target.closest('.loxa-sidebar-option');
                    const radioEl = e.target.closest('input[name="loxa-sidebar-insurance"]');
                    
                    if (optionEl || radioEl) {
                        setTimeout(() => {
                            const selectedPlan = LoxaController.getSelectedSidebarPlan();
                            if (selectedPlan && currentInsuranceData) {
                                log('[LOXA SYNC]', `Sidebar plan changed → re-rendering widget for: ${selectedPlan.code}`);
                                let checkbox = document.querySelector('.loxa-extended-badge .loxa-offer-checkbox') || document.getElementById('loxa-insurance-checkbox');
                                const isChecked = checkbox ? checkbox.checked : false;
                                LoxaController.renderWidget(currentInsuranceData, selectedPlan.code);
                                let newCheckbox = document.querySelector('.loxa-extended-badge .loxa-offer-checkbox') || document.getElementById('loxa-insurance-checkbox');
                                if (newCheckbox && isChecked) newCheckbox.checked = true;
                            }
                        }, 50);
                    }
                };
                document.addEventListener('click', syncHandler);
                document.addEventListener('change', syncHandler);
            }
        },

        attachEventListeners: function(plan, fullData, type) {
            if (!plan) return;
            log('[LOXA EVENTS]', `attachEventListeners() — type=${type}, plan=${plan.code}`);

            let linkSelector = '.loxa-details-link'; 
            if (type === 'inclusive') linkSelector = '.loxa-inclusive-details-link';

            const detailsLinks = document.querySelectorAll(linkSelector);
            const addToCartButton = document.getElementById('addToCart') || document.querySelector('button.product-form__submit[name="add"], .btn-add-cart');
            
            let boundCount = 0;
            detailsLinks.forEach(detailsLink => {
                if (detailsLink.dataset.bound) return;
                detailsLink.dataset.bound = "true";
                boundCount++;
                detailsLink.addEventListener('click', (e) => {
                    e.preventDefault();
                    log('[LOXA EVENTS]', `Details link clicked (type=${type})`);
                    if (!currentInsuranceData || !currentInsuranceData.insurable || !currentInsuranceData.active) return;
                    const addToCartForm = addToCartButton ? addToCartButton.closest('form') : null;
                    this.openSidebar(fullData, addToCartButton, addToCartForm, false, plan); 
                });
            });
            log('[LOXA EVENTS]', `Bound ${boundCount} detail link(s) for type=${type}`);

            if (type === 'extension' && !this._extensionSyncBound) {
                this._extensionSyncBound = true;
                log('[LOXA EVENTS]', 'Binding extension↔inclusive sync listener (delegated, once)');

                const syncInclusiveToExtension = () => {
                    const extBadge = document.querySelector('.loxa-extended-badge');
                    const extCb = extBadge ? extBadge.querySelector('.loxa-offer-checkbox') : null;
                    const incBadge = document.querySelector('.loxa-inclusive-badge');
                    if (!incBadge) return;

                    const isExtChecked = extCb && extCb.checked;
                    const isOptedOut = incBadge.classList.contains('loxa-opted-out');
                    log('[LOXA EVENTS]', `syncInclusiveToExtension — ext checked: ${isExtChecked}, inclusive opted-out: ${isOptedOut}`);

                    if (isExtChecked && isOptedOut) {
                        // Extension was selected → restore inclusive protection
                        const incCheckbox = incBadge.querySelector('#loxa-insurance-checkbox');
                        if (incCheckbox) {
                            incCheckbox.checked = true;
                            incCheckbox.dispatchEvent(new Event('change'));
                        }
                        log('[LOXA EVENTS]', 'Restoring inclusive widget from opted-out state (extension selected)');
                        this.toggleInclusiveOptOut(false);
                    } else if (!isExtChecked && !isOptedOut) {
                        // Extension was deselected — inclusive stays included (no change needed)
                        log('[LOXA EVENTS]', 'Extension deselected — inclusive remains included');
                    }
                };

                document.addEventListener('change', (e) => {
                    if (e.target.closest('.loxa-extended-badge')) {
                        syncInclusiveToExtension();
                    }
                });

                document.addEventListener('click', (e) => {
                    if (e.target.closest('.loxa-extended-badge')) {
                        // Delay to let checkbox state update from click
                        setTimeout(syncInclusiveToExtension, 50);
                    }
                });
            }
        },

        fetchInsurance: async function(totalPrice) {
            const productInfo = getBaseProductInfo(); 
            const thisSequence = ++fetchSequence;
            isFetching = true;

            log('[LOXA FETCH]', `fetchInsurance() — price=£${totalPrice}, sku=${productInfo.sku}, seq=${thisSequence}`);

            try {
                const params = new URLSearchParams({
                    product_sku: productInfo.sku,     
                    product_title: productInfo.title, 
                    product_price: totalPrice.toString()
                });                             

                const response = await fetch(`${CONFIG.proxyUrl}?${params}`, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                });

                if (thisSequence !== fetchSequence) {
                    warn('[LOXA FETCH]', `Stale response discarded — seq=${thisSequence}, current=${fetchSequence}`);
                    return;
                }

                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                const data = await response.json();

                if (thisSequence !== fetchSequence) {
                    warn('[LOXA FETCH]', `Stale after parse — seq=${thisSequence}, current=${fetchSequence}`);
                    return;
                }

                currentInsuranceData = data; 
                log('[LOXA FETCH]', `Response received — insurable=${data.insurable}, active=${data.active}, plans=${data.insurances?.length || 0}, integration=${data.integration_type}`);

                if (data.insurable && data.active && data.insurances?.length > 0) {
                    this.renderWidget(data);
                } else {
                    log('[LOXA FETCH]', 'Not insurable/active — removing widget');
                    this.removeWidget();
                }

            } catch (error) {
                if (thisSequence === fetchSequence) {
                    error('[LOXA FETCH]', 'Fetch error:', error);
                    this.removeWidget();
                }
            } finally {
                if (thisSequence === fetchSequence) {
                    isFetching = false;
                }
            }
        },

        findMatchingVariantId: async function(targetPrice) {
            try {
                if (!window.LoxaShopifyDev?.getInsuranceMap) {
                    warn('[LOXA VARIANT]', 'LoxaShopifyDev.getInsuranceMap not available');
                    return null;
                }
                const insuranceMapArray = await window.LoxaShopifyDev.getInsuranceMap();
                log('[LOXA VARIANT]', `Insurance map has ${insuranceMapArray.length} product(s)`);
                for (const product of insuranceMapArray) {
                    if (!product.variants) continue;
                    const match = product.variants.find(v => Math.abs(parseFloat(v.price) - parseFloat(targetPrice)) < 0.01);
                    if (match) {
                        log('[LOXA VARIANT]', `Matched variant ${match.id} for price £${targetPrice}`);
                        return match.id;
                    }
                }
                warn('[LOXA VARIANT]', `No variant matched for price £${targetPrice}`);
                return null;
            } catch (e) {
                error('[LOXA VARIANT]', 'Error:', e);
                return null;
            }
        },

        interceptAddToCart: function() {
            if (interceptBound) {
                warn('[LOXA INTERCEPT]', 'interceptAddToCart() already bound — skipping');
                return;
            }
            interceptBound = true;
            log('[LOXA INTERCEPT]', 'Binding ATC intercept listener (capture phase)');

            document.addEventListener('click', async (e) => {
                const addToCartButton = e.target.closest('#addToCart, button.product-form__submit[name="add"], button.add-to-cart, .btn-add-cart');
                if (!addToCartButton) return; 

                log('[LOXA INTERCEPT]', `ATC button clicked — ${"isIntercepting=" + isIntercepting + " isExecutingCartAdd=" + isExecutingCartAdd + " isFetching=" + isFetching + " fetchSeq=" + fetchSequence}`);

                if (isIntercepting || isExecutingCartAdd) {
                    log('[LOXA INTERCEPT]', '→ PASS-THROUGH (intercepting or executing)');
                    return; 
                }
                if (!currentInsuranceData || !currentInsuranceData.insurable || !currentInsuranceData.active || !currentInsuranceData.insurances || currentInsuranceData.insurances.length === 0) {
                    log('[LOXA INTERCEPT]', '→ PASS-THROUGH (no insurance data)');
                    return; 
                }

                const addToCartForm = addToCartButton.closest('form');
                let isMainValid = addToCartForm ? addToCartForm.checkValidity() : true;

                if (!isMainValid) {
                    log('[LOXA INTERCEPT]', '→ BLOCKED (form invalid)');
                    e.preventDefault();
                    e.stopImmediatePropagation(); 
                    addToCartForm.reportValidity();
                    return; 
                }

                let extCheckbox = document.querySelector('.loxa-extended-badge .loxa-offer-checkbox');
                let incCheckbox = document.querySelector('.loxa-inclusive-badge #loxa-insurance-checkbox');
                let stdCheckbox = document.getElementById('loxa-insurance-checkbox');
                
                const isHybrid = currentInsuranceData.integration_type === 'hybrid_extension';
                log('[LOXA INTERCEPT]', `isHybrid=${isHybrid}, ext=${extCheckbox?.checked}, inc=${incCheckbox?.checked}, std=${stdCheckbox?.checked}`);
                
                if (isHybrid) {
                    if (extCheckbox && extCheckbox.checked) {
                        log('[LOXA INTERCEPT]', '→ HYBRID: Extension checked — adding extension plan');
                        e.preventDefault();
                        e.stopImmediatePropagation(); 
                        const targetPlan = currentInsuranceData.insurances.find(plan => plan.extension);
                        LoxaController.executeCartAdd(addToCartForm, addToCartButton, targetPlan);
                    } 
                    else if (extCheckbox && !extCheckbox.checked) {
                        log('[LOXA INTERCEPT]', '→ HYBRID: Extension unchecked — opening second-chance sidebar');
                        e.preventDefault();
                        e.stopImmediatePropagation(); 
                        LoxaController.openSidebar(currentInsuranceData, addToCartButton, addToCartForm, true);
                    }
                    else if (!extCheckbox && incCheckbox && incCheckbox.checked) {
                        log('[LOXA INTERCEPT]', '→ HYBRID: No ext widget, inclusive checked — adding inclusive plan');
                        e.preventDefault();
                        e.stopImmediatePropagation(); 
                        const targetPlan = currentInsuranceData.insurances.find(plan => plan.inclusive_insurance);
                        LoxaController.executeCartAdd(addToCartForm, addToCartButton, targetPlan);
                    } else {
                        log('[LOXA INTERCEPT]', '→ HYBRID: No matching condition — PASS-THROUGH');
                    }
                } 
                else {
                    if (stdCheckbox && !stdCheckbox.checked) {
                        log('[LOXA INTERCEPT]', '→ STANDARD: Unchecked — opening second-chance sidebar');
                        e.preventDefault();
                        e.stopImmediatePropagation(); 
                        LoxaController.openSidebar(currentInsuranceData, addToCartButton, addToCartForm, true);
                    } else if (stdCheckbox && stdCheckbox.checked) {
                        log('[LOXA INTERCEPT]', '→ STANDARD: Checked — adding insurance');
                        e.preventDefault();
                        e.stopImmediatePropagation(); 
                        const targetPlan = LoxaController.getSelectedSidebarPlan() || currentInsuranceData.insurances.find(plan => plan.default_selected) || currentInsuranceData.insurances[0];
                        LoxaController.executeCartAdd(addToCartForm, addToCartButton, targetPlan);
                    } else {
                        log('[LOXA INTERCEPT]', '→ STANDARD: No checkbox found — PASS-THROUGH');
                    }
                }

            }, { capture: true }); 
        }
    };    

    const calculateLiveTotal = () => {
        let finalTotal = 0;
        
        const configState = getConfiguratorState();
        if (configState) {
            if (!configState.sizeId) {
                log('[LOXA CALC]', 'No sizeId — removing widget');
                LoxaController.removeWidget();
                previousStateString = null;
                return;
            }
            finalTotal = configState.price;
        } 
        else {
            const activeVariantId = getActiveVariantId();
            if (window.ShopifyAnalytics?.meta?.product?.variants) {
                const activeVariant = window.ShopifyAnalytics.meta.product.variants.find(v => v.id.toString() === activeVariantId?.toString());
                if (activeVariant && activeVariant.price) {
                    finalTotal = activeVariant.price / 100; 
                }
            }

            if (finalTotal === 0) {
                const priceEl = document.querySelector('#price_ppr, .price_range, .price-item--sale, .price-item--regular');
                if (priceEl && priceEl.innerText) {
                    const rawText = priceEl.innerText.replace(/[^0-9.]/g, '');
                    if (rawText) finalTotal = parseFloat(rawText);
                }
            }
        }

        currentCalculatedTotal = finalTotal;
        const productInfo = getBaseProductInfo();
        const activeVariantId = getActiveVariantId();

        const currentStateString = JSON.stringify({ 
            price: finalTotal, 
            nativeVariantId: activeVariantId,
            dynamicSku: productInfo.sku
        });

        if (currentStateString !== previousStateString) {
            log('[LOXA CALC]', `State changed — price=£${finalTotal}, variant=${activeVariantId}, sku=${productInfo.sku}`);
            previousStateString = currentStateString;
            LoxaController.fetchInsurance(finalTotal);
        }
    };

    const triggerCalculation = () => {
        clearTimeout(calcTimeout);
        calcTimeout = setTimeout(calculateLiveTotal, 250); 
    };

    const initObserver = () => {
        log('[LOXA INIT]', 'initObserver() — setting up listeners and observers');
        
        const triggerEvents = ['change', 'input'];
        triggerEvents.forEach(eventType => {
            document.addEventListener(eventType, (e) => {
                if (e.target.closest('.option-dropdown, .size-variant-selector, variant-selects, variant-radios, form[action*="/cart/add"]')) {
                    triggerCalculation();
                }
            });
        });

        document.addEventListener('click', (e) => {
            if (e.target.closest('.option-card, .step-tab, #confirmCustomHeight')) {
                setTimeout(triggerCalculation, 150); 
            }
        });

        const originalReplaceState = history.replaceState;
        history.replaceState = function() {
            originalReplaceState.apply(this, arguments);
            triggerCalculation();
        };
        const originalPushState = history.pushState;
        history.pushState = function() {
            originalPushState.apply(this, arguments);
            triggerCalculation();
        };

        const targetNodes = [
            document.querySelector('product-form'),
            document.querySelector('.product-form'),
            document.querySelector('.size-variant-selector') 
        ].filter(Boolean);

        log('[LOXA INIT]', `MutationObserver targets: ${targetNodes.length} node(s)`);

        if (targetNodes.length > 0) {
            const observer = new MutationObserver(triggerCalculation);
            const idInputs = document.querySelectorAll('input[name="id"]');
            idInputs.forEach(input => {
                observer.observe(input, { attributes: true, attributeFilter: ['value'] });
            });
            targetNodes.forEach(node => {
                observer.observe(node, { 
                    childList: true, subtree: true, attributes: true,     
                    attributeFilter: ['disabled', 'checked', 'value'] 
                });
            });
        }

        setTimeout(() => {
            LoxaController.interceptAddToCart();
            triggerCalculation();
            log('[LOXA INIT]', 'Init complete — first calculation triggered');
        }, 500);
    };    

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initObserver);
    } else {
        initObserver();
    }
})();